import {
    SET_EDITED_PATIENT,
    UPDATE_EDITED_PATIENT_FIELD,
    UPDATE_EDITED_PATIENT_VALIDATION,
    FULLFILL_PATIENT
} from '../mutations/available'

import Joi from 'joi'
import api from '../api'
import {extractErrorMessages, validate} from '@/helpers/validation'
import {extractUserErrorMessage, extractValidationErrors} from "js-core/helpers/api";
import NotificationService from '@/services/notificationService'

const editedPatientFieldsValidationSchema = {
    name: Joi.string().min(3).max(255).required(),
    email: Joi.string().email({tlds: {allow: false}}).max(255).allow(null).optional(),
    address: Joi.string().min(3).max(255).allow(null).optional(),
    birthday: Joi.string().min(10).max(10).allow(null).optional(),
}

const editedPatientValidationSchema = Joi.object({
    name: editedPatientFieldsValidationSchema.name,
    email: editedPatientFieldsValidationSchema.email,
    address: editedPatientFieldsValidationSchema.address,
    birthday: editedPatientFieldsValidationSchema.birthday
}).unknown()

export const initEditedPatient = async ({dispatch, commit}, patientId) => {
    let patient = await dispatch('getPatientOrFetch', patientId)

    if (!patient) {
        return
    }

    await commit(SET_EDITED_PATIENT, patient)
    await dispatch('validateEditedPatient')
}

export const updateEditedPatientField = async ({dispatch, commit}, {fieldName, value}) => {
    commit(UPDATE_EDITED_PATIENT_FIELD, {
        fieldName,
        value
    })

    await dispatch('validateEditedPatientField', {fieldName, value})
}

export const validateEditedPatientField = async ({state, commit}, {fieldName}) => {
    if (!editedPatientFieldsValidationSchema[fieldName]) {
        return
    }

    let validationResult = validate(editedPatientFieldsValidationSchema[fieldName], state.editedPatient.data[fieldName])

    const errors = extractErrorMessages(validationResult)

    commit(UPDATE_EDITED_PATIENT_VALIDATION, {
        errorsByFields: {
            [fieldName]: errors
        }
    })
}

export const validateEditedPatient = async ({state, commit}) => {
    let validationResult = validate(editedPatientValidationSchema, state.editedPatient.data)

    const errorsByFields = extractErrorMessages(validationResult, true)

    commit(UPDATE_EDITED_PATIENT_VALIDATION, {
        errorsByFields,
        reset: true
    })
}

export const saveEditedPatient = async ({dispatch, state, commit, rootGetters}) => {
    await dispatch('validateEditedPatient')

    if (!state.editedPatient.isValid) {
        return
    }

    if (rootGetters.progress('patients.saveEditedPatient')) {
        return
    }

    dispatch('startProgress', 'patients.saveEditedPatient', {
        root: true
    })

    try {
        const patient = await api.update(state.editedPatient.data)
        commit(SET_EDITED_PATIENT, patient)
        commit(FULLFILL_PATIENT, patient)
        NotificationService.success('Patient was updated')
    } catch (e) {
        const errorsByFields = extractValidationErrors(e)

        if (errorsByFields !== null) {
            commit(UPDATE_EDITED_PATIENT_VALIDATION, {
                errorsByFields,
                reset: true
            })
        } else {
            NotificationService.error(extractUserErrorMessage(e, 'Unable to save edited patient'))
        }
    } finally {
        dispatch('stopProgress', 'patients.saveEditedPatient', {
            root: true
        })
    }
}